export const validation = {
  titleMaxChar: 100,
  paragraphMaxChar: 300,
  blocks: {
    min: 1,
    max: 1
  }
}
